import {Block} from 'jsxstyle'

interface TooltipProps {
  name: string
  hoveredTooltip: string | null
}

const Tooltip: React.FC<TooltipProps & {children: React.ReactNode}> = ({name, hoveredTooltip, children}) => {
  if (hoveredTooltip !== name) return null

  return (
    <Block
      position="absolute"
      bottom="100%"
      left="50%"
      transform="translateX(-50%)"
      marginBottom="8px"
      backgroundColor="#333"
      color="white"
      padding="4px 8px"
      borderRadius="4px"
      fontSize="12px"
      zIndex={1000}
    >
      {children}
      <Block
        position="absolute"
        top="100%"
        left="50%"
        transform="translateX(-50%)"
        borderLeft="6px solid transparent"
        borderRight="6px solid transparent"
        borderTop="6px solid #333"
      />
    </Block>
  )
}

export default Tooltip
